import Header from "@/base/Header";
import Kicker from "@/base/Kicker";
import ContactUsForm from "./components/ContactUsForm";
import GenericPageBanner from "@/core/common/GenericPageBanner";
import FormPrivacyPolicy from './components/FormPrivacyPolicy';
import {css} from "@emotion/react";
import { rem } from "@util/convertUnits";


const ContactUsFormPage = () => {

  const formCss = css(`
    width: 100%;
    max-width: ${rem(520)};
    margin-left: auto;
    margin-right: auto;
  `);

  return (
    <div>
      <GenericPageBanner image="/images/banners/generic.jpg" localImage={true}>
        <Kicker stylesOverride={{textShadow: "0 0 1rem rgb(255,255,255)"}}>About</Kicker>
        <Header tag="h1" style={{textShadow: "0 0 1.5rem rgba(255,255,255,0.8)"}}>Send a Question or Comment</Header>
      </GenericPageBanner>

      <div className="container m-gap">

        <ContactUsForm/>
        <div css={formCss}>
          <FormPrivacyPolicy/>
        </div>

      </div>
    </div>
  );
};
export default ContactUsFormPage;
